import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-internaluserhome',
  templateUrl: './internaluserhome.component.html',
  styleUrls: ['./internaluserhome.component.css']
})
export class InternaluserhomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/home/internaluserhome/internaluserhome.component.ts